import { BillLineDebitV2, BillLineItemV2Kind } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemDebitChargebacktMock = new MockFactory<BillLineDebitV2>({
  id: 'line_item_id_02',
  amount_cents: 20001,
  reference_date: '2023-12-01T00:00:00Z',
  payer_id: 'player_id_01',
  kind: BillLineItemV2Kind.DebtChargeback,
  metadata: {
    chargeback_debt_id: 'purchase-debit-id-1',
    base_debt_id: 'base_debt_id-99',
    total_amount_cents: 20000,
    paid_amount_cents: 0,
    created_at: '2023-12-01T00:00:00Z',
    activated_at: '2022-04-10T00:00:00Z',
    due_at: '2023-12-01T00:00:00Z',
  },
})
